import React, {Component} from 'react';
import './Info.css';
import {Col, Container, Image, Row} from 'react-bootstrap';
import mehedi from '../../images/mehedi.jpg';

export default class Info extends Component {

    render() {
        return (
            <section id="infoBgImg">
                <Container className="p-5">
                    <Row className="info-row">
                        <Col lg={4} className="d-flex align-items-center">
                            <Image src={mehedi} rounded className="w-75" />
                        </Col>
                        <Col lg={6} className="d-flex align-items-center text-light">
                            <div>
                                <h1>Hi, I'M <span style={{color: '#ffcc00'}}>Mehedi Hasan</span> </h1>
                                <h3>Web developer</h3>
                                <p>
                                    Web designer from USA, California, San Francisco. I have rich experience in web site design and building, also I am good at wordpress. I love to talk with you about our unique.I help you build brand for your business
                                </p>
                                <button className="btn btn-primary px-4">Hire me</button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    }
}
